import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { z } from 'zod'

import { PageHeader } from '@/components/PageHeader'
import { Button } from '@/components/ui/button'
import { CMS_KIND_LABELS, CMS_KINDS } from '@/lib/cms/cms'
import { ContentEditor } from './-components/content-editor'

export const Route = createFileRoute('/_authenticated/admin/content_/new')({
  validateSearch: z.object({ kind: z.enum(CMS_KINDS).catch('post') }),
  component: NewContentPage,
})

function NewContentPage() {
  const { kind } = Route.useSearch()
  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        title={`New ${CMS_KIND_LABELS[kind].toLowerCase()}`}
        actions={
          <Button variant="outline" asChild>
            <Link to="/admin/content">
              <ArrowLeft data-icon="inline-start" />
              All content
            </Link>
          </Button>
        }
      />
      {/* Key on kind so switching kind from the New menu resets the form. */}
      <ContentEditor key={kind} kind={kind} initial={null} />
    </div>
  )
}
